
import React from "react";

export function SkuFormatter(cellContent, row){

    return (
        <>
            {
                row.itemNumber ?
                <>
                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                        {`${row.itemNumber}`}
                    </span>
                    <span className="text-muted font-weight-bold">
                        {`${row.sku}`}
                    </span>
                </>
                :
                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                    {`${row.sku}`}
                </span>
            }
            
        </>
    )
}